!function() {
  'use strict';

  customElements.get('pashion-size-guide') || customElements.define('pashion-size-guide', class extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('[data-pashion-size-guide-toggle]');
      this.drawer = this.querySelector('[data-pashion-size-guide-drawer]');
      this.close = this.querySelector('[data-pashion-size-guide-close]');
      this.handleToggle = () => this.openDrawer();
      this.handleClose = () => this.closeDrawer();
    }

    connectedCallback() {
      if (this.toggle) this.toggle.addEventListener('click', this.handleToggle);
      if (this.close) this.close.addEventListener('click', this.handleClose);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.handleToggle);
      if (this.close) this.close.removeEventListener('click', this.handleClose);
    }

    openDrawer() {
      if (this.drawer) {
        this.drawer.hidden = false;
        document.dispatchEvent(new CustomEvent('theme:scroll:lock'));
      }
    }

    closeDrawer() {
      if (this.drawer) {
        this.drawer.hidden = true;
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock'));
      }
    }
  });
}();
